module.exports = __webpack_public_path__ + "img/logo.08c10026.png";